import { Link } from 'react-router-dom';
import { rankingList, latestUpdates } from '@/mocks/comics';

export default function SidebarSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between mb-6">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                  最近更新
                </h3>
                <p className="text-sm text-foreground-600 mt-2">最新漫画章节及时掌握</p>
              </div>
            </div>
            <div className="bg-background-100 rounded-xl p-5">
              {latestUpdates.map((item, idx) => (
                <Link
                  key={idx}
                  to={`/comic/${item.id}`}
                  className={`flex items-center gap-4 py-3.5 hover:bg-background-50 rounded-lg px-3 transition-colors ${
                    idx !== latestUpdates.length - 1 ? 'border-b border-background-200/60' : ''
                  }`}
                >
                  <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                    idx < 3 ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-500'
                  }`}>
                    {idx + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-semibold text-foreground-950 truncate">{item.title}</h4>
                    <p className="text-xs text-foreground-600 truncate mt-0.5">{item.chapter}</p>
                  </div>
                  <span className="text-xs text-foreground-500 whitespace-nowrap flex-shrink-0">{item.time}</span>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-end justify-between mb-6">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                  排行榜
                </h3>
                <p className="text-sm text-foreground-600 mt-2">人气漫画排行</p>
              </div>
            </div>
            <div className="bg-background-100 rounded-xl p-5">
              {rankingList.map((item) => (
                <Link
                  key={item.rank}
                  to={`/comic/${item.rank}`}
                  className={`flex items-center gap-3 py-3 hover:bg-background-50 rounded-lg px-3 transition-colors ${
                    item.rank !== rankingList.length ? 'border-b border-background-200/60' : ''
                  }`}
                >
                  <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${
                    item.rank === 1
                      ? 'bg-accent-500 text-white'
                      : item.rank === 2
                      ? 'bg-accent-400 text-white'
                      : item.rank === 3
                      ? 'bg-accent-300 text-white'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-semibold text-foreground-950 truncate">{item.title}</h4>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.author}</p>
                  </div>
                  <span className="text-xs font-semibold text-accent-600 whitespace-nowrap flex-shrink-0">{item.rating}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}